/* src/app/shared/dialogs/image-adjust-dialog/image-adjust-dialog.component.scss */
.adjust-image-box {
  border-radius: 16px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  width: 848px !important;
  position: relative;
}
.adjust-image-box .header {
  display: flex;
  justify-content: space-between;
  padding: 24px;
  width: 100%;
  height: 72px;
}
.adjust-image-box .header img {
  cursor: pointer;
  width: 24px;
  height: 24px;
}
.adjust-image-box .header img:hover {
  opacity: 0.8;
}
.adjust-image-box .image-black-box {
  position: relative;
  width: 100%;
  height: 444px;
  background: #222222;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.adjust-image-box .image-black-box .img {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
}
.adjust-image-box .image-black-box .shown-area-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1;
  pointer-events: none;
}
.adjust-image-box .image-black-box .shown-area {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  border: 2px solid #6e89da;
  box-sizing: border-box;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25), 0 4px 16px rgba(0, 0, 0, 0.4);
  pointer-events: none;
}
.adjust-image-box .image-black-box .padding-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  pointer-events: none;
  background:
    repeating-linear-gradient(
      -45deg,
      rgba(255, 255, 255, 0.25),
      rgba(255, 255, 255, 0.25) 4px,
      transparent 4px,
      transparent 8px);
}
.adjust-image-box .image-black-box .crop-box {
  position: absolute;
  z-index: 5;
  border: 1px dashed #cb9def;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25), 0 1px 16px rgba(0, 0, 0, 0.4);
  border-radius: 2px;
  box-sizing: border-box;
  cursor: move;
  overflow: visible;
}
.adjust-image-box .image-black-box .crop-box .crop-handle {
  position: absolute;
  background: #cb9def;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  box-sizing: border-box;
  z-index: 6;
}
.adjust-image-box .image-black-box .crop-box .crop-handle--top,
.adjust-image-box .image-black-box .crop-box .crop-handle--bottom {
  width: 6px;
  height: 6px;
  cursor: ns-resize;
  left: 50%;
  transform: translateX(-50%);
}
.adjust-image-box .image-black-box .crop-box .crop-handle--top {
  top: -4px;
}
.adjust-image-box .image-black-box .crop-box .crop-handle--bottom {
  bottom: -4px;
}
.adjust-image-box .image-black-box .crop-box .crop-handle--left,
.adjust-image-box .image-black-box .crop-box .crop-handle--right {
  height: 6px;
  width: 6px;
  cursor: ew-resize;
  top: 50%;
  transform: translateY(-50%);
}
.adjust-image-box .image-black-box .crop-box .crop-handle--left {
  left: -4px;
}
.adjust-image-box .image-black-box .crop-box .crop-handle--right {
  right: -4px;
}
.adjust-image-box .image-black-box .crop-box .crop-handle--topleft,
.adjust-image-box .image-black-box .crop-box .crop-handle--topright,
.adjust-image-box .image-black-box .crop-box .crop-handle--bottomleft,
.adjust-image-box .image-black-box .crop-box .crop-handle--bottomright {
  width: 6px;
  height: 6px;
}
.adjust-image-box .image-black-box .crop-box .crop-handle--topleft {
  top: -4px;
  left: -4px;
  cursor: nwse-resize;
}
.adjust-image-box .image-black-box .crop-box .crop-handle--topright {
  top: -4px;
  right: -4px;
  cursor: nesw-resize;
}
.adjust-image-box .image-black-box .crop-box .crop-handle--bottomleft {
  bottom: -4px;
  left: -4px;
  cursor: nesw-resize;
}
.adjust-image-box .image-black-box .crop-box .crop-handle--bottomright {
  bottom: -4px;
  right: -4px;
  cursor: nwse-resize;
}
.adjust-image-box .legend {
  position: absolute;
  bottom: 193px;
  right: 6px;
  z-index: 10;
  border-radius: 12px;
  padding: 12px;
  background: #ffffff;
  width: 128px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25), 0 4px 16px rgba(0, 0, 0, 0.4);
}
.adjust-image-box .legend .legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.adjust-image-box .legend .legend-item span {
  font-size: 12px;
  color: #222222;
}
.adjust-image-box .legend .legend-line {
  width: 20px;
  height: 0;
  flex-shrink: 0;
}
.adjust-image-box .legend .legend-line--solid {
  border-top: 2px solid #6e89da;
}
.adjust-image-box .legend .legend-line--dashed {
  border-top: 2px dashed #d9e2ff;
}
.adjust-image-box .legend .legend-line--crop {
  border-top: 1px dashed #cb9def;
}
.adjust-image-box .legend .padding-legend {
  width: 20px;
  height: 20px;
  border-radius: 3px;
  background:
    repeating-linear-gradient(
      -45deg,
      rgba(255, 255, 255, 0.1),
      rgba(255, 255, 255, 0.1) 4px,
      transparent 4px,
      transparent 8px),
    #222222;
  flex-shrink: 0;
}
.adjust-image-box .footer {
  display: flex;
  justify-content: space-between;
  padding: 24px;
  width: 100%;
  height: 104px;
}
::ng-deep .mdc-dialog__surface {
  padding: 0 !important;
  border-radius: 16px !important;
  overflow: visible !important;
}
::ng-deep .mat-mdc-dialog-panel {
  max-width: none !important;
}
::ng-deep .mat-mdc-dialog-container {
  overflow: visible !important;
}
::ng-deep .mdc-dialog__container {
  overflow: visible !important;
}
/*# sourceMappingURL=image-adjust-dialog.component.css.map */
